import { Component, Injectable } from '@angular/core';
import * as $ from 'jquery';

@Component({
    selector: 'fisico-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['../fisico.component.css']
})
@Injectable()

export class FisicoFooter {

    constructor(){

    }

    scrollTo(id){
      $("html body").animate({
        scrollTop: $(id).offset().top
      }, 500);
    }
}
